import { createAction } from 'redux-act';
//////////////////////////////////////////////////

export const setSearchFilter = createAction('setSearchFilter');
